<template>
  <el-dialog custom-class="max-dialog1256" title="盘点单" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false"
             :append-to-body="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="仓库" :label-width="formLabelWidth" prop="cangkucode" size="small"
                        style="text-align: left;">
            <template v-if="btnvisible">
            <el-select v-model="form.cangkuname" placeholder="请选择" @change="changename" style="width: 130px"
                       :required="true" >
              <el-option
                v-for="item in jxcstoreDataf"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item">
              </el-option>
            </el-select>
            <el-select v-model="form.warehouse" size="mini" style="width: 100px" v-if="warehouse.length>1&&form.cangkucode" @change="changewarehouse">
            <el-option v-for="item in warehouse" :key="item.serial" :label="item.name" :value="item.serial"></el-option>
             </el-select>
            </template>
            <span v-else>{{form.cangkuname}}&nbsp;&nbsp;{{form.warehousename}}&nbsp;&nbsp;{{form.accdate}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item label="货品名称" :label-width="formLabelWidth" prop="seedname" size="small"
                        style="text-align: left;">
            <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData" :isShowCheckBox="false"
                        v-model="form.seedname" :treeWidth="340" v-if="btnvisible"
                        :treeHeight="350" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
            <span v-else>{{form.seedname}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="false">
        <el-col :span="10">
          <el-form-item label="盘点日期" :label-width="formLabelWidth" prop="accdate">
            <el-input v-model="form.accdate" auto-complete="off" :required="true" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="说明" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              :rows="1"
              v-model="form.remark">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="二维表" :label-width="formLabelWidth" v-show="form.filltemplate!=30">
            <TwoDimensionalTable ref="referweibiao" :precision="0" :isMakeInvent="true" :erweitable="erweitable" :cutHeight="260" :positive="true"
            ></TwoDimensionalTable>
          </el-form-item>
          <el-form-item label="右眼" :label-width="formLabelWidth" v-show="form.filltemplate==30"
                        style="display: inline-block">
            <TwoDimensionalTable ref="referweibiaoright"  :isMakeInvent="true" :precision="0" :cutHeight="260" :erweitable="erweitableright" :positive="true"
                                 style="width: 200px"
            ></TwoDimensionalTable>
          </el-form-item>
          <el-form-item label="左眼" :label-width="formLabelWidth" v-show="form.filltemplate==30"
                        style="display: inline-block">
            <TwoDimensionalTable ref="referweibiaoleft"  :isMakeInvent="true" :precision="0" :cutHeight="260" :erweitable="erweitableleft" :positive="true"
                                 style="width: 200px"
            ></TwoDimensionalTable>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="warning" @click="toZero(false)" plain v-if="btnvisible">清零</el-button>
      <el-button type="success" @click="delivergoodsScan" class="qrbtn" v-if="btnvisible" :loading="loading">打码</el-button>
      <!--<el-button type="primary" @click="saveData" v-if="btnvisible" :loading="loading">保 存</el-button>-->
      <el-button type="warning" @click="importEdit" size="mini">二维表导入</el-button>
      <el-button type="warning" @click="listImportEdit" size="mini">列表导入</el-button>
      <a href="./static/file/镜片导入格式.xls">下载模板</a>
      <input type="file" ref="fileupload1" style="display: none;" @change="change1($event)"/>
      <input type="file" ref="fileuploadList" style="display: none;" @change="changeListImport($event)"/>
      <QRCodeScanBad ref="QRCodeScanBad1" @scancodeedit="afterQRCodeScan" :noScan="true"></QRCodeScanBad>
    </div>
  </el-dialog>
</template>


<script>
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getControlData,getPrice} from '@/api/set/goodsprice';
  import {inventorySave} from '@/api/set/jxcstoreform';
  import {looklist} from '@/api/set/jxcstoreformdetail';
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import QRCodeScanBad from './QRCodeScanBad';

  export default {
    name: 'MakeInventoryEdit',
    msg: '盘点单',
    data() {
      return {
        addvisible: true,
        costpricebook: {},
        BookContent: [],
        loading:false,
        guids: '',//商品编码
        dialogFormVisible: false,
        erweitable: [],//二维表
        erweitableleft: [],//左眼二维表
        erweitableright: [],//右眼二维表
        BookContentLeft: [],
        BookContentRight: [],
        BookContent: [],
        warehouse:[],
        totalnumber:0,
        form: {  //表单数据
          accdate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
          cangkucode: '',
          cangkuname: '',
          packagesizes: '',
          seedcode: '',
          seedname: '',
          status: 10,
          formtype: 74,
          filltemplate: '',
          remark: '',
          totalnumber: 0,
          physicalstore:'',
          physicalstorecode:'',
          warehouse:'',
          warehousename:'',
        },
        jxcstoreDataf: [],//仓库
        packagesizes: [],//存储盘点数据
        formLabelWidth: '120px',
        btnvisible: true,//控制确定按钮显示、隐藏
        rules: {////////定义正则验证字段。
          cangkucode: [
            {required: true, message: '请选择仓库', trigger: 'blur'},
          ],
          seedname: [
            {required: true, message: '请选择货品', trigger: 'change'},
          ],
        },
      }
    },
    methods: {
      show() {
        this.dialogFormVisible = true;
      },
      delivergoodsScan() {//扫码发货
        var arrContent=this.getContent();
        var arr=[];
        for (let i in arrContent) {
          if (arrContent[i].P > 0) {
            var handleNum = parseInt(arrContent[i].P);
            var type = '';
            if (arrContent[i].type) {
              type = ",\"type\":\"" + arrContent[i].type + "\"";
            }
            for (let m = 0; m < handleNum; m++) {
              arr.push({
                erpserial: '',
                seedcode: this.form.seedcode,
                seedname: this.form.seedname,
                packagesize: "{\"X\":\"" + arrContent[i].X + "\",\"Y\":\"" + arrContent[i].Y + "\"" + type + "}",
                storegoodsbarcode: '', starttime: '', endtime: '',
                pipei: false
              })
            }
          }
        }
        this.$refs.QRCodeScanBad1.show({
          cangkucode: this.form.cangkucode,
          erpserial: '',
          seedcode: '',
          goods: arr,
          tableData: [],
        }, true);
      },
      afterQRCodeScan(scancodes) {//扫码后提交
         this.saveData();
      },
      //导入二维表
      importEdit() {
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            let arr = []
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              let obj = {}
              data.forEach((item) => {
                let Y = ""
                for (let X in item) {
                  obj = {}
                  if (X == "球\\柱") {
                    Y = parseFloat(item[X]).toFixed(2)
                  } else {
                    if (typeof parseFloat(item[X]) === 'number' && !isNaN(parseFloat(item[X]))) {
                      obj = {"X": parseFloat(X).toFixed(2), "Y": Y, "P": parseFloat(item[X])}
                      if (this.type) {
                        obj.type = this.type
                      }
                      arr.push(obj)
                    }
                  }
                }
              })
            }
            this.$refs.referweibiao.initBook(this.costpricebook, arr,null,this.BookContent)
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      //列表导入
      listImportEdit() {
        this.$refs.fileuploadList.value = ""
        this.$refs.fileuploadList.click()
      },
      changeListImport(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            let arr = []
            if (typeof data == "object" && (Array.isArray(data) || data instanceof Array)) {
              data.forEach((item) => {
                let Y = "", X = "", P = 0
                for (let col in item) {
                  if (col.indexOf("球镜") !== -1 || col.toUpperCase() === "Y") {
                    Y = parseFloat(item[col]).toFixed(2)
                  } else if (col.indexOf("柱镜") !== -1 || col.toUpperCase() === "X") {
                    X = parseFloat(item[col]).toFixed(2)
                  } else if (col.indexOf("数量") !== -1) {
                    P = parseFloat(item[col]) || 0
                  }
                }
                if (Y !== "" && X !== "" && P > 0) {
                  let obj = {"X": X, "Y": Y, "P": P}
                  if (this.type) {
                    obj.type = this.type
                  }
                  arr.push(obj)
                }
              })
            }
            if (arr.length > 0) {
              this.$refs.referweibiao.initBook(this.costpricebook, arr, null, this.BookContent)
            } else {
              this.$message.warning("没有有效数据可导入")
            }
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      getContent() {
        var arr = [];
        this.totalnumber = 0;
        if (this.form.filltemplate == 10 || this.form.filltemplate == 20) {
          arr = this.difference(this.erweitable, this.BookContent);
        } else if (this.form.filltemplate == 30) {
          arr = arr.concat(this.difference(this.erweitableleft, this.BookContentLeft, "L"),
            this.difference(this.erweitableright, this.BookContentRight, "R"));
        }
        return arr;
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.loading = true
            //一个二维表,过滤数量为空和0
            //10现片，20定制片，30区分左右眼
            //存储二维表过滤后的数据
           var arr=this.getContent();
            if (arr.length == 0) {
              this.$message({
                message: '请输入盘盈数量',
                type: 'warning'
              })
              this.loading = false
              return
            }
            this.form.remark=this.form.remark+' 盘盈：'+this.totalnumber;
            this.form.packagesizes = JSON.stringify(arr);
            this.form.physicalstore = this.form.seedname
            this.form.physicalstorecode = this.form.seedcode
            inventorySave(this.form).then(response => {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.dialogFormVisible = false;

              if (this.$refs.QRCodeScanBad1) {//盘盈时需要保存 唯一码
                this.$refs.QRCodeScanBad1.saveQRCode(response.data.msg);
              }
              //刷新列表
              this.$emit('bindGrid');
            });
            //
          } else {
            this.loading = false
          }
        })
      },
      difference(newNum,oldNum,type) {//差异:新的数量，原始数量
        var changeRow = []

        for (let i in this.costpricebook.BookContent) {
          var item = this.costpricebook.BookContent[i]
          var floatX= parseFloat(item.X);
          var floatY= parseFloat(item.Y);
          //原始库存量
          var Old = 0;
          // for (let j in oldNum) {
          //   if (parseFloat(oldNum[j].X) == floatX && parseFloat(oldNum[j].Y) ==floatY) {
          //     Old = oldNum[j].P;
          //     if (Old == null || Old == '')
          //       Old = 0;
          //     break;
          //   }
          // }

          //新录入的库存量
          var New = 0;
          for (let j in newNum) {
            var hasV=false;
            for (let m in newNum[j]) {
              if (parseFloat(newNum[j][m].X) == floatX&& parseFloat(newNum[j][m].Y) == floatY) {
                New = newNum[j][m].P;
                if (New == null || New == '')
                  New = 0;
                hasV=true;
                break;
              }
            }
            if(hasV)
              break;
          }

          if ((parseInt(New) - parseInt(Old)) != 0) {
            //{"X":"0.00","Y":"-2.25","type":"L"}
            var arr = {
              X: floatX.toFixed(2),
              Y: floatY.toFixed(2),
              P: parseInt(New) - parseInt(Old)
            };
            if (type)
              arr.type = type;
            this.totalnumber+=arr.P;
            changeRow.push(arr)
          }
        }
        return changeRow;
      },
      toZero(isback) {
        if (this.form.cangkucode && this.form.seedcode) {
          if (this.$refs.referweibiao)
            this.$refs.referweibiao.initBook(this.costpricebook, isback ? this.BookContent : [], null, this.BookContent)
          if (this.$refs.referweibiaoright)
            this.$refs.referweibiaoright.initBook(this.costpricebook, isback ? this.BookContentRight : [], null, this.BookContentRight)
          if (this.$refs.referweibiaoleft)
            this.$refs.referweibiaoleft.initBook(this.costpricebook, isback ? this.BookContentLeft : [], null, this.BookContentLeft)
        }
      },
      //初始化
      initForm() {
        this.costpricebook = {}
        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
          this.form.seedname = ""
          this.form.seedcode = ""
          this.form.discountdetail = ""
          this.zhujing = []
          this.qiujing = []
          this.form.remark = ''
          this.form.totalnumber = 0
          this.form.cangkucode = ''
          this.form.cangkuname = ''
        }
        this.BookContent = []//正常二维表
        this.BookContentLeft = []//左二维表
        this.BookContentRight = []//右二维表
        this.loading=false
        this.btnvisible=true;
        this.form.enabled = 1
        this.erweitable = [];
        this.erweitableleft = []
        this.erweitableright = []
        this.index = ''
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
        cusandptbyind().then(response => {
          this.jxcstoreDataf = response.data.obj
          if(this.jxcstoreDataf.length==1){
            this.changename(this.jxcstoreDataf[0]);
          }

        })
      },
      //商品树
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1,filltemplates:'10;20;30'})
        })
      },
      //选择商品树所执行的方法
      checktree1(guids, names, arr) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i]['attributes']['filltemplate']) {
            this.form.filltemplate = arr[i]['attributes']['filltemplate']
            break
          }
        }
        this.form.seedcode = guids//商品编码
        this.form.seedname = names//商品名称
        this.costpricebook = {}
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.form.seedname == "") {
          this.$message({
            message: '请选择货品',
            type: 'warning'
          })
          return
        }

        this.getXYRange()
      },
      //二维表展示范围
      getXYRange() {
        //获取库存
        getPrice({seedcode: this.form.seedcode,filterType:'cost'}).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
          } else {
            this.costpricebook = {}
          }
          if (this.form.cangkucode) {
            if (this.btnvisible) {
              this.createPriceBook()
            } else {//查看状态
              if (this.form.filltemplate == 30) {
                this.$refs.referweibiaoleft.initBook(this.costpricebook, this.BookContentLeft)
                this.$refs.referweibiaoright.initBook(this.costpricebook, this.BookContentRight)
              } else if (this.form.filltemplate != 40) {
                this.$refs.referweibiao.initBook(this.costpricebook, this.BookContent)
              }
            }
          }
        })
      },
      changewarehouse(val){
        this.form.warehouse = val;
        for(let i in this.warehouse){
          if(this.warehouse[i].serial==val){
            this.form.warehousename = this.warehouse[i].name;
            break;
          }
        }

        if (this.form.seedcode)
          this.createPriceBook()
      },
      changename(val) {
        this.form.cangkucode = val.cangkucode;
        this.form.cangkuname = val.cangkuname;
        this.warehouse=[];
        this.form.warehouse='';
        this.form.warehousename='';
        if(val.warehouse) {
          this.warehouse = JSON.parse(val.warehouse);
          if (this.warehouse <= 1) {
            this.warehouse = [];
          } else {
            this.form.warehouse = this.warehouse[0].serial;
            this.form.warehousename = this.warehouse[0].name;
          }
        }
        if (this.form.seedcode)
          this.createPriceBook()
      },
      createPriceBook() {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        //取当前库存
        // getGoodsListWithStoreDetail({seedcode:this.form.seedcode,warehouse:this.form.warehouse,
        //   cangkucode:this.form.cangkucode,
        //   minyear: yearnow,
        //   minmonth: monthnow,
        //   maxyear: yearnow,
        //   maxmonth: monthnow,
        //   nostock: 1,nolimit:'1',notransfernum:'1',nodeliverying:'1',nobuynum:'1'}).then(resStore=> {

          this.BookContent = []//正常二维表
          this.BookContentLeft = []//左二维表
          this.BookContentRight = []//右二维表

          var storeData = [];//不显示库存
          if (this.form.filltemplate == 30) {

            for(let i in storeData) {
              var pc = JSON.parse(storeData[i].packagesize)
              if (pc.type == 'L')
                this.BookContentLeft.push({X: pc.X, Y: pc.Y, P: storeData[i].subtractnum});
              else
                this.BookContentRight.push({X: pc.X, Y: pc.Y, P: storeData[i].subtractnum});
            }
            if(this.BookContentLeft.length==0){
              this.BookContentLeft.push({X: "0.00", Y: "0.00", P: 0});
            }
            if(this.BookContentRight.length==0){
              this.BookContentRight.push({X: "0.00", Y: "0.00", P: 0});
            }
            this.$refs.referweibiaoleft.initBook(this.costpricebook, this.BookContentLeft,null,this.BookContentLeft)
            this.$refs.referweibiaoright.initBook(this.costpricebook, this.BookContentRight,null,this.BookContentRight)

          } else if (this.form.filltemplate != 40) {

            for(let i in storeData) {
              var pc = JSON.parse(storeData[i].packagesize)
              this.BookContent.push({X: pc.X, Y: pc.Y, P: storeData[i].subtractnum});
            }
            if(this.BookContent.length==0){
              this.BookContent.push({X: "0.00", Y: "0.00", P: 0});
            }
            this.$refs.referweibiao.initBook(this.costpricebook, this.BookContent,null,this.BookContent)

          }
        // });


      },
    },
    components: {
      TwoDimensionalTable,
      QRCodeScanBad
    },

    mounted() {
      // getListDatabyinpd().then(response => {
      //   this.jxcstoreDataf = response.data.obj
      // })
    },
  }
</script>

<style scoped>
  .titlecolor {
    color: #20A0FF
  }

  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .erweitable td {
    border: 1px solid #E0DFDF;
    min-width: 80px;
    max-width: 100px;
    text-align: center;
    vertical-align: center;
  }

  .erweitable .content {
    border: none;
    padding: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/warehouse/MakeInventoryAdd.vue